import React from 'react'

const GreenCheckIcon = ({ style, fill = '#2CA788' }: { style?: React.CSSProperties; fill?: string }) => {
  return (
    <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
      <circle cx='14' cy='14' r='14' fill={fill} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.4972 7.625C19.2934 7.625 19.1016 7.7246 18.9851 7.892L11.438 18.6715C11.3653 18.776 11.2579 18.8451 11.1333 18.8674C11.1037 18.8725 11.0747 18.8751 11.0473 18.8751C10.9509 18.8751 10.858 18.846 10.7768 18.7897C10.7349 18.7606 10.6983 18.7251 10.6677 18.6839L8.7473 16.1239C8.62958 15.967 8.44349 15.874 8.24732 15.874C8.11095 15.874 7.98075 15.9179 7.87233 15.999C7.73912 16.0989 7.65245 16.2459 7.62846 16.4097L7.62828 16.4109C7.605 16.5756 7.64769 16.7411 7.74733 16.8739L9.66572 19.4315C9.77674 19.5797 9.90996 19.7096 10.0632 19.8159C10.3536 20.0176 10.6938 20.125 11.0458 20.125C11.1484 20.125 11.2516 20.1156 11.3524 20.0976C11.8056 20.0164 12.2011 19.7628 12.4635 19.3859L20.0093 8.60789C20.1044 8.4714 20.1415 8.30483 20.1124 8.14073C20.0834 7.97754 19.9922 7.83331 19.8548 7.73752C19.7499 7.66426 19.6255 7.625 19.4972 7.625Z'
        fill='white'
      />
    </svg>
  )
}

export default GreenCheckIcon
